import Vue from 'vue';

Vue.component('video-search', () => import(/* webpackChunkName: "video-search" */ '~/components/video-search'));
Vue.component('video-widget', () => import(/* webpackChunkName: "video-widget" */ '~/components/video-widget'));
Vue.component('video-frame', () => import(/* webpackChunkName: "video-frame" */ '~/components/video-frame'));
Vue.component('auth-by-code', () => import(/* webpackChunkName: "auth-by-code" */ '~/components/auth-by-code'));
Vue.component('auth-by-code-card', () => import(/* webpackChunkName: "auth-by-code-card" */ '~/components/auth-by-code-card'));
Vue.component('modal', () => import(/* webpackChunkName: "modal" */ '~/components/modal'));
Vue.component('modal-package', () => import(/* webpackChunkName: "modal-package" */ '~/components/modal-package'));
